import Header from './components/Header';
import Landing from './components/Landing';
import About from './components/About';
import Resume from './components/Resume';
import Projects from './components/Projects';
import Contact from './components/Contact';

function App() {  
  return (
    <>
      <Landing />
      <Header />
      <About />
      <Resume />
      <Projects />
      <Contact />
    </>
  );
}

export default App;
